import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        themes: {
            light: {
                primary: '#5A6476',
                secondary: '#59A0D8',
                accent: '#8c9eff',
                error: '#b71c1c',
            },
        },
    },
});
